import React, { useContext, useState, useEffect } from "react"
import styles from './FilterPaymentForm.module.scss'
import { Context as FilterContext } from '../../../contexts/FilterPaymentContext'
import { UserCheckboxSelectLabel, Section  } from '../../../components'
import {
  createUserCheckbokLabel
} from '../../../generators/labelGenerator'

const FilterPaymentForm = ({
  changed,
  users,
  onClosedClick,
  callback
}) => {
  const {
    state,
    setPayers,
    setOwers,
    setTouched
  } = useContext(FilterContext)

  useEffect(() => {
    if (users) {
      if (!state.touched) {
        setPayers(users)
        setOwers(users)
      }
    }
  }, [users])

  const filterDisabled = (users) => {
    return []
  }

  const handleClosed = () => {
    onClosedClick()
  }

  const handlePayerSelectCallback = (selected) => {
    setPayers(selected)
  }

  const handleOwerSelectCallback = (selected) => {
    setOwers(selected)
  }

  return(
    <div className={styles.container}>
      <div className={styles.labels}>
        <Section name="包含付款者" style={{ marginTop: '16px' }}/>
          <UserCheckboxSelectLabel
          key="filter-form-user-checkboxk-select-label-payer"
            hideWarning={true}
            users={users}
            selectedObjects={state.payers.value}
            callback={handlePayerSelectCallback}
          />
        <Section name="包含分款者" style={{ marginTop: '16px' }}/>
        <UserCheckboxSelectLabel
          key="filter-form-user-checkboxk-select-label-ower"
          hideWarning={true}
          users={users}
          selectedObjects={state.owers.value}
          callback={handleOwerSelectCallback}
        />
      </div>
    </div>
  )
}

export default FilterPaymentForm
